window.addEventListener('DOMContentLoaded', function() {
  $.ajax({
    url: '/collections/all?type=' + localStorage.getItem('wishlist') + '&view=prlist',
    dataType: 'html',
    type: 'GET',
    success: function(data) {
      if ($(data).find('.grid_bx').length) {
        $('.wlnull').hide();
        $('#wishlist').html(data);
        $(theme.init);
      }
    },
    error: function() { console.log('ajax error'); },
    complete: function() {}
  });

  $(document).on('click', '.removeItem', function(e) {
    e.preventDefault();
    var item = $(this).parents('.gitem');
    var str = localStorage.getItem('wishlist');
    str = str.replace($(this).attr('href'), '');
    str = str.replace('++', '+');
    localStorage.setItem('wishlist', str);
    item.fadeOut(500);
    setTimeout(removeItem, 500, item);
  });

  function removeItem(item) {
    item.remove();
    if (localStorage.getItem('wishlist') == '+' || localStorage.getItem('wishlist') == '') {
      localStorage.removeItem('wishlist');
      $('.wlnull').show();
      $('.favCount').addClass('hide');
    } else {
      var str = String(localStorage.getItem('wishlist')).split('+');
      for (var i = 0; i < str.length; i++) {
        if (str[i] != '') {
          $('.favCount').text(i);
        }
      }
    }
  }
});
